import { connect } from "react-redux";

var Spinner = require("components/utility/Spinner");
var BraveCheckbox = require("components/utility/BraveCheckbox");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var CurrentUser = require("lib/account/CurrentUser");

require("data/exports/expandable_student_list_selector.scss");

@connect(
    (state, props) => {
        // MOUNT STUDENT WITHIN STUDENT LISTS
        var studentLists = {}
        // filter student lists if selected a school org
        var filters = props.persistentData.selectedSchoolOrg ? { school_org_id: props.persistentData.selectedSchoolOrg.id } : {}
        _.each(RosterSelectors.studentListsByAdminId({ state, adminId: CurrentUser.get().id, filters }), (sl) => {
            studentLists[sl.id] = sl
            studentLists[sl.id].students = []
            studentLists[sl.id].primary_students = []
        })

        _.each(state.students, (student) => {
            if (student.student_list_ids) {
                _.each(student.student_list_ids.all, (id) => {
                    if (studentLists[id]) {
                        studentLists[id].students.push(student)
                    }
                })
                if (studentLists[student.student_list_ids.primary]) {
                    studentLists[student.student_list_ids.primary].primary_students.push(student)
                }
            }
        })

        var loading = RosterSelectors.isLoadingStudentLists({ state }) || RosterSelectors.isLoadingStudents({ state })

        return {
            studentLists: _.values(studentLists),
            loading,
        }
    }
)

class ExpandableStudentListsSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedstudentLists: [],
            selectedStudents: props.persistentData.selectedStudents || [],
            selectedStudentLists: props.persistentData.selectedStudentLists || [],
            allSelected: false
        };
    }

    ///// HELPERS /////

    persistentSelectedStudentLists() {
        var { persistentData } = this.props
        if (_.has(persistentData, 'selectedStudentLists')) {
            return persistentData.selectedStudentLists
        }
    }

    selectedOrganizationType() {
        var { persistentData } = this.props
        if (_.has(persistentData, 'selectedOrganizationType')) {
            return persistentData.selectedOrganizationType
        }
    }

    perStudentOrganization() {
        return (
            this.selectedOrganizationType() &&
            this.selectedOrganizationType() == 'per-student'
        )
    }

    perStudentListOrganization() {
        return (
            this.selectedOrganizationType() &&
            this.selectedOrganizationType() == 'per-class'
        )
    }

    // check if all students within a student list are selected
    hasAllSelectedStudents(slID) {
        var { selectedStudents } = this.state
        var { studentLists } = this.props
        var studentIDs = _.pluck(studentLists.filter(sl => sl.id === slID)[0].students, 'id');
        var selected = studentIDs.filter(id => selectedStudents.includes(id));
        return selected.length == studentIDs.length;
    }

    // returns number of students that are selected in a given list
    studentsSelectedPerList(slID) {
        var { selectedStudents } = this.state
        var { studentLists } = this.props;
        if (!this.perStudentListOrganization()) {
            var selectedStudentPerList = _.map(studentLists, sl => {
                var studentIDs = _.pluck(studentLists.filter(sl => sl.id === slID)[0].students, 'id');
                var selected = studentIDs.filter(id => selectedStudents.includes(id));
                return { slID: sl.id, num_selected: _.size(selected) }
            })
            var config = _.findWhere(selectedStudentPerList, { slID: slID })
            if (config && config.num_selected) {
                return <span className='studentsSelectedCount'>({config.num_selected} students selected)</span>
            }
        }
    }

    // returns if all of the student lists are selected
    allStudentListsSelected() {
        var { studentLists } = this.props;
        var { selectedStudentLists } = this.state;

        return studentLists && _.size(studentLists) == _.size(selectedStudentLists)
    }

    ///// VALIDATORS /////

    validSelectedStudents() {
        return !_.isEmpty(this.state.selectedStudents)
    }

    validSelectedStudentLists() {
        return !_.isEmpty(this.state.selectedStudentLists)
    }

    validSelection() {
        return this.perStudentListOrganization() ? this.validSelectedStudentLists() : this.validSelectedStudents()
    }

    ///// HANDLERS /////

    handleSLSelection(slID) {
        var { selectedStudentLists, selectedStudents } = this.state;
        var { studentLists } = this.props;

        var studentIds = _.pluck(studentLists.filter(sl => sl.id === slID)[0].students, 'id');
        if (selectedStudentLists.includes(slID)) {
            selectedStudentLists.splice(selectedStudentLists.indexOf(slID), 1);
            var selectedStudents = selectedStudents.filter(s => !_.includes(studentIds, s))
        } else {
            selectedStudentLists.push(slID);
            var selectedStudents = _.uniq([...selectedStudents, ...studentIds])
        }

        this.setState({ selectedStudentLists, selectedStudents, allSelected: this.allStudentListsSelected() });
    }

    handleAllSlSelect() {
        var { studentLists } = this.props;
        var { allSelected } = this.state

        if (allSelected) {
            // Deselect all
            var selectedStudents = []
            var selectedStudentLists = []
            var allSelected = false
        } else {
            var studentIds = _.pluck(_.flatten(_.map(studentLists, (sl) => { return sl.students })), 'id');
            var selectedStudents = _.uniq([...studentIds])
            var selectedStudentLists = _.pluck(studentLists, 'id')
            var allSelected = true
        }

        this.setState({ selectedStudentLists, selectedStudents, allSelected });
    }

    handleSLToggle(slID) {
        var { expandedstudentLists } = this.state;
        if (expandedstudentLists.includes(slID)) {
            expandedstudentLists.splice(expandedstudentLists.indexOf(slID), 1);
        } else {
            expandedstudentLists.push(slID);
        }
        this.setState({ expandedstudentLists });
    }

    handleStudentSelection(studentID) {
        var { selectedStudentLists, selectedStudents } = this.state
        var { studentLists } = this.props
        var slIDs = studentLists.filter(c => _.pluck(c.students, 'id').includes(studentID)).map(c => c.id);

        if (_.isEmpty(slIDs)) { return null }

        if (selectedStudents.includes(studentID)) {
            selectedStudents.splice(selectedStudents.indexOf(studentID), 1);
            _.each(slIDs, slID => {
                if (selectedStudentLists.includes(slID) && !this.hasAllSelectedStudents(slID)) {
                    selectedStudentLists.splice(selectedStudentLists.indexOf(slID), 1);
                }
            })
        } else {
            selectedStudents.push(studentID);
        }

        this.setState({ selectedStudents, selectedStudentLists })
    }

    handleRetreatStage() {
        var { selectedStudents, selectedStudentLists } = this.state
        this.props.onRetreat({ selectedStudents, selectedStudentLists })
    }

    ///// SUBMIT /////
    onSubmit() {
        var { selectedStudents, selectedStudentLists } = this.state

        var errorMessage = this.perStudentListOrganization() ? "Please Select Classes Before Continuing" : "Please Select Students Before Continuing"

        if (!this.validSelection()) {
            this.renderErrorAlert(errorMessage)
        } else {
            this.props.onComplete({ selectedStudentLists, selectedStudents })
        }
    }

    render() {
        var { studentLists } = this.props;
        var { expandedstudentLists, selectedStudents, selectedStudentLists, allSelected } = this.state;

        if (this.props.loading) {
            return <Spinner placeholder={true} scale={1.7} />
        }

        return (
            <div className="slDropdownSelectorContainer">
                <div className="dropdownSelector">
                    <div className="dropdownSelector__dropdown">
                        <div className="dropdownSelector__slName">
                            <BraveCheckbox
                                onClick={() => this.handleAllSlSelect()}
                                value={allSelected} />
                            <div className='slNameContainer' onClick={() => this.handleAllSlSelect()}>
                                <span className="boldBlue">Select All</span>
                            </div>
                        </div>
                        {studentLists.map((sl, i) => (
                            <div key={i} className="dropdownSelector__slName">
                                <BraveCheckbox
                                    onClick={() => this.handleSLSelection(sl.id)}
                                    value={selectedStudentLists.includes(sl.id)} />
                                <div className='slNameContainer' onClick={() => this.handleSLToggle(sl.id)}>
                                    <span className="boldBlue">{sl.name}</span> {this.studentsSelectedPerList(sl.id)}
                                </div>
                                {!this.perStudentListOrganization() && expandedstudentLists.includes(sl.id) && (
                                    <div className="dropdownSelector__students">
                                        {sl.students.map((student, j) => (
                                            <div key={j} className="dropdownSelector__studentsCheckboxContainer">
                                                <BraveCheckbox
                                                    onClick={() => this.handleStudentSelection(student.id)}
                                                    value={selectedStudents.includes(student.id)} />
                                                <span>{`${student.first_name.substring(0, 3)}. ${$wr.truncate(student.last_name, 15)}`}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="onSubmitContainer">
                    <button className='backBtn' onClick={() => this.handleRetreatStage()}>Back</button>
                    {this.validSelection() && (
                        <button className='nextBtn' onClick={() => this.onSubmit()}>Next</button>
                    )}
                </div>
            </div>
        );
    }

    componentDidMount() {
        // preselect student lists if all students in list are preselected
        var { studentLists } = this.props
        var selectedStudentLists = studentLists.map(sl => {
            if (this.hasAllSelectedStudents(sl.id)) {
                return sl.id
            }
        })

        var allSelected = this.allStudentListsSelected() ? true : false

        this.setState({ selectedStudentLists: _.uniq(_.compact([...this.persistentSelectedStudentLists() || [], ...selectedStudentLists])), allSelected })
    }
}

ExpandableStudentListsSelector.propTypes = StrictPropTypes({
    endOnboarding: PropTypes.func,
    handleAdvanceStage: PropTypes.func,
    onSubmit: PropTypes.func,
    onComplete: PropTypes.func,
    onRetreat: PropTypes.func,
    track: PropTypes.array,
    persistentData: PropTypes.object,
    currentAdmin: PropTypes.object,
    organizationTypes: PropTypes.array,
    organizationOptions: PropTypes.array,
    handlePrint: PropTypes.func,
});

module.exports = ExpandableStudentListsSelector;


// WEBPACK FOOTER //
// ./modules/components/data/exports/ExpandableStudentListSelector.js